export default function(contentType, id, section = false) {
  return `/editor/${contentType}/${id}${
    section && contentType === "story" ? "/content" : ""
  }`;
}
